import { Link } from 'react-router-dom';
import { newMovies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function LatestMovies() {
  return (
    <section className="w-full px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
              <a href="#latest">最新上映</a>
            </h2>
            <p className="text-sm text-foreground-600 mt-1">新鲜出炉，第一时间尝鲜</p>
          </div>
          <Link
            to="/category/kehuan"
            className="text-sm text-foreground-500 hover:text-primary-400 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            更多新片
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" data-product-shop="">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}